export const environment = {
  production: false,
  baseUrl: 'https://apprezzoo.ovh/',
  shopApiUrl: 'https://backend.apprezzoo.ovh/shop-api',
  paginatorSettings: {
    rows: 6,
    rowsPerPageOptions: [6, 12, 18],
    showCurrentPageReport: true,
    showFirstLastIcon: true,
  },
  maxFileSize: 10000000,
};
